/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getBooleanDecoder,
  getBooleanEncoder,
  getDiscriminatedUnionDecoder,
  getDiscriminatedUnionEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
  type GetDiscriminatedUnionVariant,
  type GetDiscriminatedUnionVariantContent,
} from '@solana/kit';
import {
  getEquatableOperatorDecoder,
  getEquatableOperatorEncoder,
  getIntegerOperatorDecoder,
  getIntegerOperatorEncoder,
  type EquatableOperator,
  type EquatableOperatorArgs,
  type IntegerOperator,
  type IntegerOperatorArgs,
} from '.';

export type BubblegumTreeConfigAssertion =
  | { __kind: 'TreeCreator'; value: Address; operator: EquatableOperator }
  | { __kind: 'TreeDelegate'; value: Address; operator: EquatableOperator }
  | { __kind: 'TotalMintCapacity'; value: bigint; operator: IntegerOperator }
  | { __kind: 'NumMinted'; value: bigint; operator: IntegerOperator }
  | { __kind: 'IsPublic'; value: boolean; operator: EquatableOperator }
  | { __kind: 'IsDecompressible'; value: number; operator: EquatableOperator };

export type BubblegumTreeConfigAssertionArgs =
  | { __kind: 'TreeCreator'; value: Address; operator: EquatableOperatorArgs }
  | { __kind: 'TreeDelegate'; value: Address; operator: EquatableOperatorArgs }
  | {
      __kind: 'TotalMintCapacity';
      value: number | bigint;
      operator: IntegerOperatorArgs;
    }
  | {
      __kind: 'NumMinted';
      value: number | bigint;
      operator: IntegerOperatorArgs;
    }
  | { __kind: 'IsPublic'; value: boolean; operator: EquatableOperatorArgs }
  | {
      __kind: 'IsDecompressible';
      value: number;
      operator: EquatableOperatorArgs;
    };

export function getBubblegumTreeConfigAssertionEncoder(): Encoder<BubblegumTreeConfigAssertionArgs> {
  return getDiscriminatedUnionEncoder([
    [
      'TreeCreator',
      getStructEncoder([
        ['value', getAddressEncoder()],
        ['operator', getEquatableOperatorEncoder()],
      ]),
    ],
    [
      'TreeDelegate',
      getStructEncoder([
        ['value', getAddressEncoder()],
        ['operator', getEquatableOperatorEncoder()],
      ]),
    ],
    [
      'TotalMintCapacity',
      getStructEncoder([
        ['value', getU64Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
    [
      'NumMinted',
      getStructEncoder([
        ['value', getU64Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
    [
      'IsPublic',
      getStructEncoder([
        ['value', getBooleanEncoder()],
        ['operator', getEquatableOperatorEncoder()],
      ]),
    ],
    [
      'IsDecompressible',
      getStructEncoder([
        ['value', getU8Encoder()],
        ['operator', getEquatableOperatorEncoder()],
      ]),
    ],
  ]);
}

export function getBubblegumTreeConfigAssertionDecoder(): Decoder<BubblegumTreeConfigAssertion> {
  return getDiscriminatedUnionDecoder([
    [
      'TreeCreator',
      getStructDecoder([
        ['value', getAddressDecoder()],
        ['operator', getEquatableOperatorDecoder()],
      ]),
    ],
    [
      'TreeDelegate',
      getStructDecoder([
        ['value', getAddressDecoder()],
        ['operator', getEquatableOperatorDecoder()],
      ]),
    ],
    [
      'TotalMintCapacity',
      getStructDecoder([
        ['value', getU64Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
    [
      'NumMinted',
      getStructDecoder([
        ['value', getU64Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
    [
      'IsPublic',
      getStructDecoder([
        ['value', getBooleanDecoder()],
        ['operator', getEquatableOperatorDecoder()],
      ]),
    ],
    [
      'IsDecompressible',
      getStructDecoder([
        ['value', getU8Decoder()],
        ['operator', getEquatableOperatorDecoder()],
      ]),
    ],
  ]);
}

export function getBubblegumTreeConfigAssertionCodec(): Codec<
  BubblegumTreeConfigAssertionArgs,
  BubblegumTreeConfigAssertion
> {
  return combineCodec(
    getBubblegumTreeConfigAssertionEncoder(),
    getBubblegumTreeConfigAssertionDecoder()
  );
}

// Data Enum Helpers.
export function bubblegumTreeConfigAssertion(
  kind: 'TreeCreator',
  data: GetDiscriminatedUnionVariantContent<
    BubblegumTreeConfigAssertionArgs,
    '__kind',
    'TreeCreator'
  >
): GetDiscriminatedUnionVariant<
  BubblegumTreeConfigAssertionArgs,
  '__kind',
  'TreeCreator'
>;
export function bubblegumTreeConfigAssertion(
  kind: 'TreeDelegate',
  data: GetDiscriminatedUnionVariantContent<
    BubblegumTreeConfigAssertionArgs,
    '__kind',
    'TreeDelegate'
  >
): GetDiscriminatedUnionVariant<
  BubblegumTreeConfigAssertionArgs,
  '__kind',
  'TreeDelegate'
>;
export function bubblegumTreeConfigAssertion(
  kind: 'TotalMintCapacity',
  data: GetDiscriminatedUnionVariantContent<
    BubblegumTreeConfigAssertionArgs,
    '__kind',
    'TotalMintCapacity'
  >
): GetDiscriminatedUnionVariant<
  BubblegumTreeConfigAssertionArgs,
  '__kind',
  'TotalMintCapacity'
>;
export function bubblegumTreeConfigAssertion(
  kind: 'NumMinted',
  data: GetDiscriminatedUnionVariantContent<
    BubblegumTreeConfigAssertionArgs,
    '__kind',
    'NumMinted'
  >
): GetDiscriminatedUnionVariant<
  BubblegumTreeConfigAssertionArgs,
  '__kind',
  'NumMinted'
>;
export function bubblegumTreeConfigAssertion(
  kind: 'IsPublic',
  data: GetDiscriminatedUnionVariantContent<
    BubblegumTreeConfigAssertionArgs,
    '__kind',
    'IsPublic'
  >
): GetDiscriminatedUnionVariant<
  BubblegumTreeConfigAssertionArgs,
  '__kind',
  'IsPublic'
>;
export function bubblegumTreeConfigAssertion(
  kind: 'IsDecompressible',
  data: GetDiscriminatedUnionVariantContent<
    BubblegumTreeConfigAssertionArgs,
    '__kind',
    'IsDecompressible'
  >
): GetDiscriminatedUnionVariant<
  BubblegumTreeConfigAssertionArgs,
  '__kind',
  'IsDecompressible'
>;
export function bubblegumTreeConfigAssertion<
  K extends BubblegumTreeConfigAssertionArgs['__kind'],
  Data,
>(kind: K, data?: Data) {
  return Array.isArray(data)
    ? { __kind: kind, fields: data }
    : { __kind: kind, ...(data ?? {}) };
}

export function isBubblegumTreeConfigAssertion<
  K extends BubblegumTreeConfigAssertion['__kind'],
>(
  kind: K,
  value: BubblegumTreeConfigAssertion
): value is BubblegumTreeConfigAssertion & { __kind: K } {
  return value.__kind === kind;
}
